import * as i0 from '@angular/core';
import { EventEmitter, forwardRef, Component, Input, ViewChild, Output } from '@angular/core';
import * as i1 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { GoogleMapsModule } from '@angular/google-maps';
import { getFormControlFrom } from '@elotech/angular-components/utils';
import * as i2 from '@elotech/angular-components/pipes';
import { PipesModule } from '@elotech/angular-components/pipes';

class GooglePlacesAutocompleteComponent {
    get value() {
        return this._value;
    }
    set value(value) {
        if (value !== this._value) {
            this._value = value;
            this.onChange(this._value);
            this.onTouched();
        }
    }
    writeValue(value) {
        this.value = value;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    constructor(injector) {
        this.injector = injector;
        this.disabled = false;
        this.placeholder = '';
        this.focus = new EventEmitter();
        this.blur = new EventEmitter();
        this.selectPlace = new EventEmitter();
        this._value = '';
        this.touched = false;
        this.onChange = (value) => { };
        this.onTouched = () => { };
    }
    ngOnInit() {
        this.formControl = getFormControlFrom(this.injector);
    }
    ngAfterViewInit() {
        this.getPlaceAutocomplete();
    }
    getPlaceAutocomplete() {
        const autocomplete = new google.maps.places.Autocomplete(this.inputAutocomplete.nativeElement, {
            componentRestrictions: { country: 'BR' },
            types: ['geocode'], // 'establishment' / 'address' / 'geocode'
            bounds: this.currentLocation ? new google.maps.Circle({
                center: this.currentLocation,
                radius: 5000
            }).getBounds() || undefined : undefined
        });
        google.maps.event.addListener(autocomplete, 'place_changed', () => {
            const place = autocomplete.getPlace();
            this.selectPlace.emit(place);
            this.writeValue(place.formatted_address);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: GooglePlacesAutocompleteComponent, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: GooglePlacesAutocompleteComponent, isStandalone: true, selector: "elo-google-places-autocomplete", inputs: { currentLocation: "currentLocation", required: "required", disabled: "disabled", placeholder: "placeholder" }, outputs: { focus: "focus", blur: "blur", selectPlace: "selectPlace" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: forwardRef(() => GooglePlacesAutocompleteComponent),
            }
        ], viewQueries: [{ propertyName: "inputAutocomplete", first: true, predicate: ["inputAutocomplete"], descendants: true }], ngImport: i0, template: `
      <input class="input"
        type="text"
        (focus)="focus.emit($event)"
        (blur)="blur.emit($event); onTouched()"
        autocomplete="off"
        role="presentation"
        [(ngModel)]="value" [disabled]="disabled" type="text" [placeholder]="placeholder"
        [disabled]="disabled"
        [required]="(formControl | controlRequired) || required"
        #inputAutocomplete style="width: 100%"
        >
    `, isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "ngmodule", type: GoogleMapsModule }, { kind: "ngmodule", type: PipesModule }, { kind: "pipe", type: i2.ControlRequiredPipe, name: "controlRequired" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: GooglePlacesAutocompleteComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'elo-google-places-autocomplete',
                    standalone: true,
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        GoogleMapsModule,
                        PipesModule
                    ],
                    template: `
      <input class="input"
        type="text"
        (focus)="focus.emit($event)"
        (blur)="blur.emit($event); onTouched()"
        autocomplete="off"
        role="presentation"
        [(ngModel)]="value" [disabled]="disabled" type="text" [placeholder]="placeholder"
        [disabled]="disabled"
        [required]="(formControl | controlRequired) || required"
        #inputAutocomplete style="width: 100%"
        >
    `,
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            multi: true,
                            useExisting: forwardRef(() => GooglePlacesAutocompleteComponent),
                        }
                    ]
                }]
        }], ctorParameters: () => [{ type: i0.Injector }], propDecorators: { currentLocation: [{
                type: Input
            }], required: [{
                type: Input
            }], disabled: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], inputAutocomplete: [{
                type: ViewChild,
                args: ['inputAutocomplete']
            }], focus: [{
                type: Output
            }], blur: [{
                type: Output
            }], selectPlace: [{
                type: Output
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { GooglePlacesAutocompleteComponent };
